import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {WorkoutTemplate} from '../../domain/workout-template';
import type {WorkoutTemplateId} from '../../domain/workout-template-id.value-object';
import type {WorkoutRepository} from '../ports/workout.repository';

export type GetWorkoutTemplateInput = {
  readonly templateId: WorkoutTemplateId;
};

export class GetWorkoutTemplate
  implements UseCase<[GetWorkoutTemplateInput], WorkoutTemplate>
{
  constructor(private readonly repository: WorkoutRepository) {}

  execute(
    input: GetWorkoutTemplateInput,
  ): Promise<Result<WorkoutTemplate, WorkoutError>> {
    return this.repository.getTemplate(input.templateId);
  }
}
